import _ from "lodash"
import { UUM_URL } from "../../utils/Config"
import { findInObjectById, updateObjectById } from "../../utils/SchemaParseUtils"
import { validateAllMandatoryAttr } from "../../utils/ValidationUtils"
import { setContentLoading, setCurrentMergedData, setCurrModalMergedData, setTextFieldErr, setUmcNotification, setValidateState } from "../reducers/CommonReducer"
import { createModelItem,createModelItemForGroup,updateModelItemForGroup, deleteModelItem, getSchemaDataResponse, getTableList, updateModelItem,getPickupGroupTableList,getHuntingGroupTableList } from "./CommonActions"
import { setDisableCreateBtn, setProfileTableList, setUserTableList, setUserDetailData, setDisableMultiDvcDECTOKBtn, 
    setValidateForDECTUserDelete, setGroupTableList, setHuntGroupTableList, setDirectorySynchroTableList, setDirectorySynchroConfigData, setDirectorySynchroCompareDetailedData, setProfileDetailData } from "../reducers/UUMReducer"
import { getSessionItem } from "../../utils/storageUtils"
import { CC_PRODUCT_ID, TOKEN_2 } from "../../utils/Constants"
import { DIRECTORY_SYNCHRO_URL } from "../../utils/Config"
import confirmModal from "../../components/common/confirmModal"

/*****USER-PROFILES******/

/* Get Profiles Table data */
export const getProfileList = () => {
    const request = {
        url: `${UUM_URL}/data/list/easyuserprofile/${getSessionItem(CC_PRODUCT_ID)}`,
        action: setProfileTableList
    }
    return (dispatch, getState) => {
        dispatch(getTableList(request))
    }
}

/* Create user profile */
export const createUserProfile = (callback) => {

    return (dispatch, getState) => {
        dispatch(createModelItem(`${UUM_URL}/data/easyuserprofile`, callback))
    }
}

/* get user profile data */
export const getProfileData = (selectedProfile, validate = false, callback) => {
    return (dispatch) => {
        const request = {
            url: `${UUM_URL}/data/easyuserprofile/${selectedProfile}/?validate=${validate}`,
            action: setProfileDetailData,
            callback: (response) => {
                if (callback) callback(response)
            }
        }

        dispatch(getSchemaDataResponse(request))
    }
}

/* Update user profile */
export const updateUserProfile = (id, callback) => {

    return (dispatch, getState) => {
        dispatch(updateModelItem(`${UUM_URL}/data/easyuserprofile/${id}`, callback))
    }
}

/* Delete custom User profile */
export const deleteUserProfile = (id, callback) => {

    return (dispatch, getState) => {
        dispatch(deleteModelItem(`${UUM_URL}/data/easyuserprofile/${id}`, callback))
    }
}

/*****USERS******/

/* Get Users Table data */
export const getUsersList = (callback) => {
    const request = {
        url: `${UUM_URL}/data/list/easyuser/${getSessionItem(CC_PRODUCT_ID)}`,
        action: setUserTableList
    }

    // return (dispatch, getState) => {
    //     dispatch(getTableList(request))
    // }
    return async (dispatch) => {
        try {
            dispatch(getTableList(request))
            if (callback) callback()
        } catch (error) {
            console.error("Error fetching table list:", error)
            if (callback) callback()
        }
    }
}

export const getUsersList2 = () => {
    const request = {
        url: `${UUM_URL}/data/list/easyuser2/${getSessionItem(CC_PRODUCT_ID)}`,
        action: setUserTableList
    }

    return (dispatch, getState) => {
        dispatch(getTableList(request))
    }
}

/* Create user */
export const createUser = (callback) => {

    return (dispatch, getState) => {
        dispatch(createModelItem(`${UUM_URL}/data/easyuser`, callback))
    }
}

/* Create pickup group*/
export const createPickupGroup = ( data, callback ) => {

     return (dispatch, getState) => {
        dispatch(createModelItemForGroup(`${UUM_URL}/data/pickupgroup`, callback, data))
    }
}

export const createHuntingGroup = ( data, callback ) => {

    return ( dispatch, getState ) => {
        dispatch(createModelItemForGroup(`${UUM_URL}/data/huntinggroup`, callback, data))
    }
}

export const updatePickupGroup = (id,data, callback ) => {
    return (dispatch, getState) => {
        dispatch(updateModelItemForGroup(`${UUM_URL}/data/pickupgroup/${btoa(unescape(encodeURIComponent(id)))}`, callback, data))
    }
}

export const updateHuntingGroup = (id, data, callback ) => {
    return ( dispatch, getState) => {
        dispatch(updateModelItemForGroup(`${UUM_URL}/data/huntinggroup/${encodeURIComponent(id)}`, callback, data))
    }
}

/* Update user */
export const updateUser = (id, data, callback) => {

    return (dispatch, getState) => {
        dispatch(updateModelItem(`${UUM_URL}/data/easyuser/${encodeURIComponent(id)}`, callback, data))
    }
}

/* Get user data */
export const getUserData = (id, action=true, callback=null) => {

    return (dispatch, getState) => {
        const request = { url: `${UUM_URL}/data/easyuser/${encodeURIComponent(id)}`, action: action ? setUserDetailData : null, callback: callback }
        dispatch(getSchemaDataResponse(request))
    }
}

/* Delete User */
export const deleteUser = (id, callback) => {

    return (dispatch, getState) => {
        dispatch(deleteModelItem(`${UUM_URL}/data/easyuser/${encodeURIComponent(id)}`, callback))
    }
}

/* Get Multi device schema */
export const getMultideviceSchema = (callback) => {

    return (dispatch, getState) => {
        const request = { url: `${UUM_URL}/schema/detail/easyusermultidevices`, action: null, callback }
        dispatch(getSchemaDataResponse(request))
    }
}

/* Get Multi device Data */
export const getMultideviceData = (id, callback) => {
    return (dispatch, getState) => {
        const request = { url: `${UUM_URL}/data/easyusermultidevices/${id}`, action: null, callback }
        dispatch(getSchemaDataResponse(request))
    }
}

/* Validate dn on DECT user creation */
export const primaryDECTCreation = () => {
    return (dispatch, getState) => {

        const state = getState()

        const currentMergedData = state.common.currentMergedData
        const validateStatus = validateAllMandatoryAttr(currentMergedData)

        if (validateStatus) {
            dispatch(setContentLoading(true))
            dispatch(setValidateState(false))
            dispatch(createUser(async (status, response) => {
                if (status) {
                    const updatedData1 = await updateObjectById(currentMergedData, "decttype", (data) => {
                        let tempData = _.cloneDeep(data)
                        if (tempData?.buttonaddon) {
                            tempData.buttonaddon.disabled = false // enable register button
                        }

                        return tempData
                    })

                    const updatedData2 = await updateObjectById(updatedData1, "umcsettype", (data) => {
                        let tempData = _.cloneDeep(data)
                        if (tempData) {
                            tempData.disabled = true // disable umcsettype radio-button
                        }

                        return tempData
                    })

                    const updatedData3 = await updateObjectById(updatedData2, "dectdirectorynumber", (data) => {
                        let tempData = _.cloneDeep(data)
                        if (tempData) {
                            tempData.disabled = true
                            tempData.buttonaddon.disabled = true // disable validate button
                        }

                        return tempData
                    })

                    // dispatch(setUmcNotification({
                    //     type: "success",
                    //     message: "Validation successful",
                    //     description: ""
                    // }))

                    dispatch(setCurrentMergedData(updatedData3))
                    dispatch(setContentLoading(false))
                    dispatch(setValidateForDECTUserDelete(true))
                } else {
                    dispatch(setTextFieldErr({ id: "dectdirectorynumber", status: "error" }))
                    dispatch(setContentLoading(false))
                    confirmModal({
                        title: "LABEL_FAILED",
                        content: response?.errorMessage ?? "MSG_VALIDATION_FAILED",
                        type: "error",
                        okText: "LABEL_OK"
                    })
                }
            }))
        } else {
            dispatch(setValidateState(true))
        }
    }
}

/* Register DECT */
export const registerDECT = () => {
    return (dispatch, getState) => {
        dispatch(setContentLoading(true))

        dispatch(updateModelItem(`${UUM_URL}/data/easyuser/register`, async (status, resp) => {
            if (status) {
                dispatch(setDisableCreateBtn(false)) //enable create btn 
                // Set device image and service status got from response
                const currentMergedData = getState().common.currentMergedData
                const updatedData = await updateObjectById(currentMergedData, "decttype", (data) => {
                    let tempData = _.cloneDeep(data)
                    // const resp = response?.response
                    if (tempData && resp) {
                        tempData.value = resp.decttype
                        tempData.iconName = resp.iconName
                        tempData.iconHelp = resp.iconHelp
                        tempData.imageaddon = {
                            imageIcon: resp.imageIcon,
                        }
                        if (tempData.buttonaddon)
                            tempData.buttonaddon.disabled = true // disable register button
                    }

                    return tempData
                })
                dispatch(setCurrentMergedData(updatedData))
                dispatch(setContentLoading(false))
                // dispatch(setUmcNotification({
                //     type: "success",
                //     message: "DECT Registration successful",
                //     description: ""
                // }))
            } else {
                dispatch(setContentLoading(false))
                confirmModal({
                    title: "LABEL_FAILED",
                    content: resp?.errorMessage ? resp.errorMessage : `MSG_DECT_REG_FAILED`,
                    type: "error",
                    okText: "LABEL_OK"
                })
            }
        }))
        // }
    }
}

/* DECT multidevice creation */
export const multideviceDECTCreation = () => {
    return (dispatch, getState) => {
        const state = getState()
        const currModalMergedData = state.common.currModalMergedData

        // dispatch(setContentLoading(true))
        const handleDECTValidateResp = async (status, response) => {
            if (status) {
                const updatedData1 = await updateObjectById(currModalMergedData, "decttype", (data) => {
                    let tempData = _.cloneDeep(data)
                    if (tempData) {
                        tempData.disabled = true // disable decttype radio-btn
                    }

                    return tempData
                })
                const updatedData2 = await updateObjectById(updatedData1, "dectdirectorynumber", (data) => {
                    let tempData = _.cloneDeep(data)
                    if (tempData) {
                        tempData.disabled = true // disable decttype radio-btn
                        tempData.buttonaddon.disabled = true // disable validate btn
                    }

                    return tempData
                })
                const updatedData3 = await updateObjectById(updatedData2, "type", (data) => {
                    let tempData = _.cloneDeep(data)
                    if (tempData?.buttonaddon) {
                        tempData.buttonaddon.disabled = false // enable Register btn
                    }

                    return tempData
                })

                // dispatch(setUmcNotification({
                //     type: "success",
                //     message: "Validation successful"
                // }))

                dispatch(setCurrModalMergedData(updatedData3))
                // dispatch(setContentLoading(false))
                dispatch(setTextFieldErr({ id: "dectdirectorynumber", status: "" }))
            } else {
                dispatch(setTextFieldErr({ id: "dectdirectorynumber", status: "error" }))
                confirmModal({
                    title: "LABEL_FAILED",
                    content: response?.errorMessage ?? "MSG_VALIDATION_FAILED",
                    type: "error",
                    okText: "LABEL_OK"
                })
                // dispatch(setContentLoading(false))
            }
        }

        dispatch(createModelItem(`${UUM_URL}/data/easyusermultidevices/dectvalidate`, handleDECTValidateResp, currModalMergedData))
    }
}

/* DECT multidevice register */
export const multideviceDECTRegister = () => {

    return (dispatch, getState) => {
        const currModalMergedData = getState().common.currModalMergedData

        const handleDECTRegisterResp = async (status, resp) => {
            if (status) {
                const updatedData = await updateObjectById(currModalMergedData, "dect", (data) => {
                    let tempData = _.cloneDeep(data)
                    // const resp = response?.response
                    // Set device image and service status got from response
                    if (tempData && resp) {
                        tempData.secondaryIcon = resp.iconName
                        tempData.secondaryHelp = resp.iconHelp
                        tempData.imageName = resp.imageName

                        tempData.attribute.map(attr => {
                            if (attr.id === "type") {
                                attr.buttonaddon.disabled = true // disable Register btn
                                attr.value = resp?.decttype
                            }

                            return attr
                        })
                    }

                    return tempData
                })
                dispatch(setCurrModalMergedData(updatedData))
                dispatch(setDisableMultiDvcDECTOKBtn(false))

                // dispatch(setUmcNotification({
                //     type: "success",
                //     message: "DECT Registration successful",
                //     description: ""
                // }))
            } else {
                confirmModal({
                    title: "LABEL_FAILED",
                    content: resp?.errorMessage ? resp.errorMessage : `MSG_DECT_REG_FAILED`,
                    type: "error",
                    okText: "LABEL_OK"
                })
            }
        }

        dispatch(updateModelItem(`${UUM_URL}/data/easyusermultidevices/register`, handleDECTRegisterResp, currModalMergedData))
    }
}

export const handlePinCodeBtnChange = () => {
    return async (dispatch, getState) => {
        const currentMergedData = getState().common.currentMergedData
        let tempData = _.cloneDeep(currentMergedData)
        const updatedData = await updateObjectById(tempData, "secretcode", (data) => {
            let tempData = _.cloneDeep(data)
            if (tempData?.buttonaddon) {
                tempData.access = "READWRITE" // Let Pin code field editable
                tempData.value = ""  // Reset masked value
            }

            return tempData
        })
        dispatch(setCurrentMergedData(updatedData))
    }
}

export const deleteDECTOnTabChange = (callback) => {

    return (dispatch, getState) => {
        dispatch(setContentLoading(true))
        const currentMergedData = getState().common.currentMergedData
        const dnAttr = findInObjectById(currentMergedData, "dectdirectorynumber")

        dnAttr?.value && dispatch(deleteUser(dnAttr.value, (status, response) => {
            dispatch(setContentLoading(false))
            callback(status)
            if (!status) {
                console.log("DECT: Deletion failed")
            }
        }))
    }
}

export const refreshMultideviceIcons = (dnAttr, callback) => {

    return (dispatch, getState) => {

        dispatch(getUserData(dnAttr.value, false, async (response) => {
            if (!response?.domain?.length) {
                console.warn("domain missing or invalid in API response");
                return;
            }

            const currentMergedData = _.cloneDeep(getState().common.currentMergedData)
            const latestMultideviceAttr = findInObjectById(response.domain, "multidevice")
            
            if (latestMultideviceAttr?.enum) {
                // Update latest Multidevice data to primary user detail view
                const updatedData = await updateObjectById(currentMergedData, "multidevice", (multideviceAttr) => {
                    let tempData = _.cloneDeep(multideviceAttr)
                    tempData.enum = tempData.enum.map(device => {
                        const latestDeviceVal = latestMultideviceAttr.enum.find(item => item.id === device?.id)

                        if (latestDeviceVal && latestDeviceVal.value !== "null") {
                            if (latestDeviceVal.value === "true")
                                return _.merge(device, latestDeviceVal)
                            else {
                                device.help = ""
                                device.secondaryHelp = ""
                                device.secondaryIcon = ""
                                device.value = "false"

                                return device
                            }
                        }
                    })

                    return tempData
                });
                dispatch(setCurrentMergedData(updatedData))
                dispatch(setContentLoading(false))
                callback && callback()
            } else {
                dispatch(setContentLoading(false))
                callback && callback()
            }
        }))
    }
}


//Get Pickup Groups List
export const getGroupList = () => {

    const request = {
        url: `${UUM_URL}/data/list/pickupgroup/${getSessionItem(CC_PRODUCT_ID)}`,
        action: setGroupTableList
    }
    return (dispatch, getState) => {
        dispatch(getPickupGroupTableList(request))
    }
}



/* Delete pickup group */
export const deletePickupGroup = (id, callback) => { 
    return (dispatch, getState) => {
        dispatch(deleteModelItem(`${UUM_URL}/data/pickupgroup/${btoa(unescape(encodeURIComponent(id)))}`, callback))
    }
}

//Get Hunt Groups List
export const getHuntGroupList = () => {
    const request = {
        url: `${UUM_URL}/data/list/huntinggroup/${getSessionItem(CC_PRODUCT_ID)}`,
        action: setHuntGroupTableList
    }
    return (dispatch, getState) => {
        dispatch(getHuntingGroupTableList(request))
    }
}

/* Delete Hunt group */
export const deleteHuntingGroup = (id, callback) => {

    return (dispatch, getState) => {
        dispatch(deleteModelItem(`${UUM_URL}/data/huntinggroup/${encodeURIComponent(id)}`, callback))
    }
}

export const getDirectorySynchroUserList = (callback) => {
    const request = {
        url: `${DIRECTORY_SYNCHRO_URL}/directorySynchro/users`,
        action: setDirectorySynchroTableList
    }
    
    return async (dispatch) => {
        try {
            dispatch(getTableList(request))
            if (callback) callback()
                dispatch(setContentLoading(false))
        } catch (error) {
            console.error("Error fetching table list:", error)
            if (callback) callback()
                dispatch(setContentLoading(false))
        }
    }
}


export const getDirectoryConfigData = (callback) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`${DIRECTORY_SYNCHRO_URL}/directorySynchro/getConfigData`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`,
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      // dispatch 
      dispatch(setDirectorySynchroConfigData(data))
      dispatch(setContentLoading(false))

      if (callback) callback(null, data)
    } catch (error) {
      console.error("Error fetching config data:", error)
      if (callback) callback(error, null)
      dispatch(setContentLoading(false))
    }
  }
}


export const deleteDirectoryConfigData = (url) => {
  return async (dispatch) => {
    try {
      const response = await fetch(url, {
        method: "DELETE", 
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json();
      console.log("Delete API Response:", data);
      dispatch(setContentLoading(false))
      return data
    } catch (err) {
      console.error("Error calling Delete API:", err)
      dispatch(setContentLoading(false))
      throw err
    }
  }
}



export const deleteDirectoryUsers = (url, payload, setDirectorySynchroTableList) => {
  return async (dispatch) => {
    try {
      const response = await fetch(url, {
        method: "DELETE", 
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`,
        },
         body:JSON.stringify(payload) 
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json();
      console.log("Delete API Response:", data);
      dispatch(getDirectorySynchroUserList(setDirectorySynchroTableList))
      dispatch(setContentLoading(false))
      return data
    } catch (err) {
      console.error("Error calling Delete API:", err)
      dispatch(setContentLoading(false))
      throw err
    }
  }
}

export const getDirectrySynchroUserData = ( directorySynchroSCIMID, directrySynchroDN) => {
  return async (dispatch) => {
    const SCIMID = directorySynchroSCIMID
    const DN = directrySynchroDN
    const url =  `${DIRECTORY_SYNCHRO_URL}/directorySynchro/updateUser?SCIMID=${SCIMID}&DN=${DN}`
    try {
      const response = await fetch(url, {
        method: "GET", 
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json();
      console.log("Get API Response:", data);
      dispatch(setUserDetailData(data.response[0]))
      dispatch(setContentLoading(false))
      return data
    } catch (err) {
      console.error("Error calling Delete API:", err)
      dispatch(setContentLoading(false))
      throw err
    }
  }
}

export const addDirectrySynchroComments = ( directorySynchroSCIMID, directrySynchroDN) => {
  return async (dispatch) => {
    const SCIMID = directorySynchroSCIMID
    const DN = directrySynchroDN
    const url =  `${DIRECTORY_SYNCHRO_URL}/directorySynchro/addComments?SCIMID=${SCIMID}&DN=${DN}`
    try {
      const response = await fetch(url, {
        method: "PUT", 
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json();
      console.log("Get API Response:", data);
      dispatch(setContentLoading(false))
      return data
    } catch (err) {
      console.error("Error calling  API:", err)
      dispatch(setContentLoading(false))
      throw err
    }
  }
}



export const getDirectrySynchroCompareData = ( directorySynchroSCIMID, directrySynchroDN) => {
  return async (dispatch) => {
    const SCIMID = directorySynchroSCIMID
    const DN = directrySynchroDN
    const url =  `${DIRECTORY_SYNCHRO_URL}/directorySynchro/compareUser?SCIMID=${SCIMID}&DN=${DN}`
    try {
      const response = await fetch(url, {
        method: "GET", 
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json();
      console.log("Get API Response:", data);
      dispatch(setDirectorySynchroCompareDetailedData(data.response[0]))
      dispatch(setContentLoading(false))
      return data
    } catch (err) {
      console.error("Error calling  API:", err)
      dispatch(setContentLoading(false))
      throw err
    }
  }
}
